import StatementsTab from "Components/Pages/UserProfile/UserProfile/UserProfileTabs/StatementsTab/StatementsTab";
import AccountDetailsTab from "Components/Pages/UserProfile/UserProfile/UserProfileTabs/AccountDetailsTab/AccountDetailsTab";

export enum UserProfileTabStrings {
  details = "Account Details",
  statements = "Statements",
  disbursements = "CYCLE",
  rewards = "REWARD",
}

export const TabRoutes = Object.keys(UserProfileTabStrings);
export const TabLabels = Object.values(UserProfileTabStrings);

export { StatementsTab, AccountDetailsTab };
